module.exports = __webpack_public_path__ + "img/italy-eye-and-ear-diseases-female.9dc7453d.png";